import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for `/settlement/*` — `settlement.verify.tsx` sits alongside
 * this file, which makes TanStack Router treat this file as the PARENT of
 * `/settlement/verify` (see `bookings.tsx`'s comment for the full
 * explanation of the flat file-route pitfall; task 13's fix note flagged
 * this exact file as having the identical shape). The settings UI itself
 * lives in `settlement.index.tsx` (`/settlement/`).
 */
export const Route = createFileRoute('/settlement')({
  component: SettlementLayout,
});

function SettlementLayout() {
  return <Outlet />;
}
